var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Example"}},[_c('div',[_c('b-button',{staticStyle:{"float":"right"},attrs:{"size":"sm","variant":"info","disabled":_vm.localBtnDisabled},on:{"click":_vm.downloadPdf}},[_c('i',{staticClass:"fa fa-angle-double-down",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.localBtnText)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }